import React, { isValidElement } from "react";
import ProjectTile from "./projectTile";
import { useIsDevice } from "../../../utils/hooks";

function ProjectsGrid({ tiles, afterRightCol }) {
  const { isMobile } = useIsDevice();
  return (
    <>
      <div className="projects-grid__row projects-grid__row--left projects-grid__row--mobile">
        {tiles.map((tile, idx) => {
          if (isValidElement(tile)) {
            return React.cloneElement(tile, { key: idx });
          } else {
            return (
              <ProjectTile
                tile={tile}
                key={idx}
                entryAnimation="FADE_LEFT"
                useSquareImg={idx % 2}
              />
            );
          }
        })}
      </div>
      <div className="projects-grid__row projects-grid__row--left projects-grid__row--desktop">
        {tiles
          .filter((_, idx) => isMobile || !(idx % 2))
          .map((tile, idx) => {
            if (isValidElement(tile)) {
              return React.cloneElement(tile, { key: idx });
            } else {
              return (
                <ProjectTile
                  tile={tile}
                  key={idx}
                  entryAnimation="FADE_LEFT"
                  useSquareImg={idx % 2}
                />
              );
            }
          })}
      </div>
      <div className="projects-grid__row projects-grid__row--right projects-grid__row--desktop">
        {!isMobile &&
          tiles
            .filter((_, idx) => idx % 2)
            .map((tile, idx) => {
              return (
                <ProjectTile
                  tile={tile}
                  key={idx}
                  delay={0.2}
                  entryAnimation="FADE_RIGHT"
                  useSquareImg={!(idx % 2)}
                />
              );
            })}
        {afterRightCol}
      </div>
    </>
  );
}

export default ProjectsGrid;
